module.exports = __webpack_public_path__ + "static/media/confirm-entry-selected.71f0c009.svg";